import { css } from "@emotion/react";
import { constants } from "@newsela/angelou";

const angelouUI = constants.colors.ui;
const greyDark = angelouUI.neutral[600];

export const textualContainer = css`
  background-color: white;
  bottom: 0;
  position: absolute;
  height: 132px;
  width: 100%;
  padding: 5px 25px;
`;

export const contentCardCss = css`
  & > div {
    display: block;
    & > div:first-child > img {
      objectfit: cover;
    }
  }
`;

export const titleCss = css`
  margin-bottom: 8px;
`;

export const tagCss = css`
  padding: 0 8px;
  border-radius: 20px;
  width: fit-content;
  font-size: 0.8em;
  color: white;
  background-color: ${greyDark};
`;

export const metadataTagsCss = css`
  padding-top: 5px;
  display: flex;
  & > div:first-child {
    margin-right: 8px;
  }
`;
